var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_110100_4517)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.76202 4.26275C3.85355 4.17122 3.9777 4.11979 4.10715 4.11979H13.75C14.0722 4.11979 14.3333 3.85862 14.3333 3.53646C14.3333 3.21429 14.0722 2.95312 13.75 2.95312H4.10715C3.66828 2.95312 3.24739 3.12747 2.93706 3.43779C2.62673 3.74812 2.45239 4.16902 2.45239 4.60789V14.2507C2.45239 14.5729 2.71356 14.8341 3.03573 14.8341C3.35789 14.8341 3.61906 14.5729 3.61906 14.2507V4.60789C3.61906 4.47844 3.67048 4.35429 3.76202 4.26275ZM16.381 16.3937C16.381 16.6632 16.1625 16.8818 15.8929 16.8818H6.78578C6.51622 16.8818 6.29769 16.6632 6.29769 16.3937V7.28652C6.29769 7.01695 6.51622 6.79842 6.78578 6.79842H15.8929C16.1625 6.79842 16.381 7.01695 16.381 7.28652V16.3937ZM15.8929 18.0484C16.8068 18.0484 17.5477 17.3076 17.5477 16.3937V7.28652C17.5477 6.37262 16.8068 5.63176 15.8929 5.63176H6.78578C5.87188 5.63176 5.13102 6.37262 5.13102 7.28652V16.3937C5.13102 17.3076 5.87188 18.0484 6.78578 18.0484H15.8929Z",
    fill: "#E42082"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_110100_4517"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.b4cffbf1d7d0c5cd5f4daf3bf2daf1a7.svg";
export { ForwardRef as ReactComponent };